import { getUsersLink } from '~/utils/getLinks';
import { useEditUserHeader } from './hooks';
import { EditUserHeaderPresentation } from './presentations';

type Props = {
  /** 利用者ID */
  userId: number;
};

/**
 * 利用者編集ヘッダー Container
 *
 * - API から氏名を取得してパンくずリストを表示する
 * - 親コンポーネント（Screen）で Suspense にラップすること
 */
export const EditUserHeader: React.FC<Props> = ({ userId }) => {
  const { fullName } = useEditUserHeader({ userId });

  return <EditUserHeaderPresentation fullName={fullName} indexHref={getUsersLink()} />;
};
